/// <amd-module name="Search/Shared/Components/LoadMore/index" />
export * from "./LoadMore";
export * from "./LoadMore.Props";
